module.exports = __webpack_public_path__ + "img/94af4fe.svg";